<div class="sts-header">
  <div class="row first-row">
    <h3 app-sts-cms-txt key="{{key}}" class="col-16 title-object" role="heading"><ng-content></ng-content></h3>
    <div class="col-8" *ngFor="let h of sides; let i = index">
      <ng-template  *ngTemplateOutlet="h.template" ></ng-template>
    </div>
  </div>
  <div>
    <div class="sts-header-message col-24 animate-all"
      [ngClass]="{'active': (texts && texts.length) || (errors && errors.length) }" class="{{getClassCode(errors)}} {{getClassCode(texts)}}">

      <ul *ngIf="errors && errors.length && errors[0].level !== 4">
        <li  *ngFor="let item of errors; let i = index"  app-sts-cms-txt alttext="{{item.description}}"  key="{{item.code}}" role="alert">
          {{item.description}}
        </li>
      </ul>

      <ul *ngIf="errors && errors.length && errors[0].level === 4">
        <li  app-sts-cms-txt key="sts-password-blacklist-title">Your password must NOT include:</li>
        <li *ngFor="let item of errors; let i = index"  app-sts-cms-txt ignore="{{item.description}}" key="{{item.code}}" role="alert">
          {{item.description}}
        </li>
      </ul>
      <ul *ngIf="texts && texts.length && texts[0].level === 4">
        <li  app-sts-cms-txt key="sts-password-policy-title">Your password must include:</li>
        <li *ngFor="let item of texts; let i = index">
          <span [innerHtml]="item.description"></span>
        </li>
      </ul>
    </div>
  </div>

</div>
